import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/game/logo-1.webp";
import Img2 from "../../../images/locationgcc/game/logo-2.webp";
import Img3 from "../../../images/locationgcc/game/logo-3.webp";
import Img4 from "../../../images/locationgcc/game/logo-4.webp";
import Img5 from "../../../images/locationgcc/game/logo-5.webp";
import Img6 from "../../../images/locationgcc/game/logo-6.webp";
import Img7 from "../../../images/locationgcc/web/logo-7-white.webp";
import Img8 from "../../../images/locationgcc/game/logo-8.webp";
import Img9 from "../../../images/locationgcc/web/logo-9-white.webp";
import Img10 from "../../../images/locationgcc/web/logo-10-white.webp";
import Img11 from "../../../images/locationgcc/game/logo-11.webp";
import Img12 from "../../../images/locationgcc/game/logo-12.webp";
import Img13 from "../../../images/locationgcc/game/logo-13.webp";
import Img14 from "../../../images/locationgcc/web/logo-14-white.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import BgImg from "../../../images/locationgcc/game/tech-stack-dubai.webp";

function Brand(props) {
  return (
    <div
      className="brandsol game-dubai-stack p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="my-auto text-center"
          >
            <h2>
              <span>The Tech Stack at TekRevol:</span> Our Tools to Build the
              Next-Gen Mobile Game Apps
            </h2>
            <p>
              At TekRevol, we use modern technologies and development frameworks
              to shape our vision of the technological future. As one of the
              leading professional game development companies in Dubai, we build
              games around lasting, impactful ideas, deliver value, and serve
              the changing needs of the projects.
            </p>
            <div className="brand_box">
              <div className="brand_img">
                <LazyLoadImage
                  src={Img1}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img2}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img3}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img4}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img5}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img6}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img7}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img8}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img9}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img10}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img11}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img12}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img13}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img14}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Brand;
